import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { ElevationService } from './elevation.service';

@Injectable({
  providedIn: 'root',
})
export class CoOpService {
  constructor(private elevationService: ElevationService) {}

  createInvoice(coOp): Observable<any> {
    return this.elevationService.postData('/co-op/invoice', coOp, undefined, {
      headers: { timeout: '90000' },
    });
  }

  createCoOp(coOp: FormData): Observable<any> {
    return this.elevationService.postData('/co-op', coOp);
  }

  uploadAdditionalFiles(coOp: FormData): Observable<any> {
    return this.elevationService.postData('/co-op/additionalFiles', coOp);
  }

  deleteFile(coOp_id, file_uuid) {
    return this.elevationService.postData(
      `/co-op/${coOp_id}/deleteFile/${file_uuid}`,
    );
  }

  getAll(): Observable<any> {
    return this.elevationService.getData('/co-op');
  }

  sendEmail(id, email: any): Observable<any> {
    return this.elevationService.postData(`/co-op/send/${id}`, email);
  }

  getAllByAccount(account_num): Observable<any> {
    return this.elevationService.getData(`/co-op/account/${account_num}`);
  }

  getByMonth(account_num, month): Observable<any> {
    return this.elevationService.getData(
      `/co-op/byMonth/${account_num}?month=${month}`,
    );
  }
}
